import { render, staticRenderFns } from "./review_order.vue?vue&type=template&id=e248343e&scoped=true"
import script from "./review_order.vue?vue&type=script&lang=js"
export * from "./review_order.vue?vue&type=script&lang=js"
import style0 from "./review_order.vue?vue&type=style&index=0&id=e248343e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e248343e",
  null
  
)

export default component.exports